(function($){



const marquee = document.querySelector(".Care_marquee");
const track = marquee?.querySelector(".Care_row");

if (window.innerWidth > 767 && track) {
  track.innerHTML += track.innerHTML;
}


// const marquee = document.querySelector(".Care_marquee");
// const trackm = marquee?.querySelector(".Care_row");

// let animation;
// let isDuplicated = false;

// function initMarquee() {
//   if (window.innerWidth > 767 && trackm && !animation) {

//     // Duplicate only once
//     if (!isDuplicated) {
//       trackm.innerHTML += trackm.innerHTML;
//       isDuplicated = true;
//     }

//     const firstSetWidth = trackm.scrollWidth / 2;

//     animation = trackm.animate(
//       [
//         { transform: "translateX(0)" },
//         { transform: `translateX(-${firstSetWidth}px)` }
//       ],
//       {
//         duration: 40000,
//         iterations: Infinity,
//         easing: "linear"
//       }
//     );

//     // Hover pause
// let currentX = 0;

// marquee.addEventListener("mouseenter", () => {
//   if (!animation) return;

//   const computedStyle = window.getComputedStyle(trackm);
//   const matrix = new DOMMatrixReadOnly(computedStyle.transform);
//   currentX = matrix.m41; // current translateX value

//   animation.cancel();
//   trackm.style.transform = `translateX(${currentX}px)`;
// });

// marquee.addEventListener("mouseleave", () => {
//   const firstSetWidth = trackm.scrollWidth / 2;

//   const remainingDistance = -firstSetWidth - currentX;
//   const remainingDuration =
//     (remainingDistance / -firstSetWidth) * 40000;

//   animation = trackm.animate(
//     [
//       { transform: `translateX(${currentX}px)` },
//       { transform: `translateX(-${firstSetWidth}px)` }
//     ],
//     {
//       duration: remainingDuration,
//       easing: "linear"
//     }
//   );

//   animation.onfinish = () => {
//     trackm.style.transform = "";
//     initMarquee(); // restart clean infinite loop
//   };
// });
//   }
// }

// function destroyMarquee() {
//   if (window.innerWidth <= 767 && animation) {
//     animation.cancel();
//     animation = null;
//   }
// }

// initMarquee();

// window.addEventListener("resize", () => {
//   destroyMarquee();
//   initMarquee();
// });



$('.TeamMembersSlider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.TeamMembersNav'
});
$('.TeamMembersNav').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: '.TeamMembersSlider',
  arrows: true,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  centerMode: false,
  infinite: true,
  focusOnSelect: true,
  responsive: [
     {
      breakpoint: 767,
      settings: {
        speed: 300,
        slidesToShow: 1,
         infinite: true,
        variableWidth: true

      }
    },

  ]
});

$(document).ready(function () {

  $(".TeamMembersCard .read-more").click(function (e) {
    e.preventDefault();

    var parentCard = $(this).closest(".TeamMembersCard");
    var moreText = parentCard.find(".moreText");

    moreText.toggleClass("active");

    if (moreText.hasClass("active")) {
      $(this).text("Read Less");
    } else {
      $(this).text("Read More");
    }
   $('.TeamMembersSlider').slick('setPosition');
  });

$('.modal__toggle').click(function () {

  $('html').addClass('hidden-s');
  lenis.stop();

});

$('.search-modal__close-button').click(function () {

  $('html').removeClass('hidden-s');
  lenis.start();

});
$('.modal-overlay').click(function () {

  $('html').removeClass('hidden-s');
  lenis.start();

});

});



$('.partners_testimonial_slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.1195 4L7.51953 12L13.1195 20H14.9995L9.39953 12L14.9995 4H13.1195Z' fill='currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.8805 20L16.4805 12L10.8805 4L9.00047 4L14.6005 12L9.00047 20L10.8805 20Z' fill='currentcolor'/></svg></button>",
  infinite: true,
  responsive: [
     {
      breakpoint: 767,
      settings: {
        slidesToShow: 1

      }
    },

  ]
});



$('.product_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: true,
    dots: false,
  fade: true,
  asNavFor: '.product_thumb'
});



  $('.product_thumb').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product_for',
  arrows: false,
  vertical: true,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  centerMode: false,
  focusOnSelect: true,
  responsive: [
     {
      breakpoint: 767,
      settings: {
          vertical: false,
       arrows: false

      }
    },

  ]
});


// Toggle dropdown
$(document).on('click', '.brand_option_wrap > .brand_toggle', function (e) {
  e.preventDefault();
  e.stopPropagation(); // prevent bubbling

  $(this).next('.brand_option').slideToggle(300);
});

// Click on dropdown link → close
$('.brand_option li a').click(function () {
  $(this).closest('.brand_option').slideUp(300);
});

// Outside click → close dropdown
$(document).click(function (e) {
  if (!$(e.target).closest('.brand_option_wrap').length) {
    $('.brand_option').slideUp(300);
  }
});

$('.column-options-wrapper a').click(function (e) {
  e.preventDefault();

  var grid = $('#product-grid');

  grid.removeClass('grid--3-col-desktop grid--4-col-desktop');

  if ($(this).hasClass('normal-column')) {
    grid.addClass('grid--3-col-desktop');
  } else {
    grid.addClass('grid--4-col-desktop');
  }

  $('.column-options-wrapper a').removeClass('active');
  $(this).addClass('active');
});

$('.filter-icon-m').click(function(){
  $('body').addClass('open-filter');
})

$('.page-overlay').click(function(){
  $('body').removeClass('open-filter');
})
$(document).on('click', '.close-filter', function () {
  $('body').removeClass('open-filter');
});
$('ul.accordion').accordion();

 AOS.init();

//    const lenis = new Lenis({
//                   autoRaf: true,
//                   smoothWheel:true,
//                });

// lenis.stop();

// $(document).ready(function(){
//     lenis.start();
// });

window.lenis = new Lenis({
  anchors:true,
  autoRaf: true,
  smoothWheel: true,
  smoothTouch: false,      // important for mobile
  allowNestedScroll: true  // VERY important
});



document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 800); // delay helps if page content loads slowly
    }
  }
});

})(jQuery);










